export default "__VITE_ASSET__71b9bb6e__"